import { Injectable, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AlertService } from './alert.service';
import { ThemeSpinnerService } from './themeSpinner.service';
import { Router } from '@angular/router';
import 'rxjs/add/operator/timeout';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class RequestService implements OnChanges, OnInit, OnDestroy {

	public constructor(protected _router: Router,
		protected _alertService: AlertService,
		protected _themeSpinnerService: ThemeSpinnerService,
		protected _http: HttpClient) {
	}

	/* --------------------- */

	public ngOnChanges() { }

	public ngOnInit() { }

	public ngOnDestroy() { }

	/* --------------------- */

	public makeRequest(url: string,
		params: Object = {},
		callbackOK: any = () => { },
		callbackKO: any = () => { },
		targetSpinner?: string,
		overlayVisible?: boolean,
		blockerTarget?: string,
		timeout = 100000,
		modeGet?: boolean,
		withoutJsonFormat?: boolean): Subscription {


		// add language to params

		// set default http headers
		var headers = new HttpHeaders();
		headers = headers.set('Authorization', 'Basic ');
		headers = headers.set('Content-Type', 'application/json');

		// show ajax spinner
		this._themeSpinnerService.show(targetSpinner, overlayVisible, blockerTarget);

		var req: any;

		if (modeGet) {

			req = this._http.get(BASE_URL + url, { headers: headers })
				.timeout(timeout)

		} else {

			var paramsJsonStr = JSON.stringify(params);
			var paramsB64 = Buffer.from(paramsJsonStr).toString('base64');
			req = this._http.post(BASE_URL + url, 'params={"params":"' + paramsB64 + '"}', { headers: headers })
				.timeout(timeout)

		}
		var sub: Subscription = req.subscribe(

			data => {

				// success callback e gli passo la callback
				callbackOK(data);

				// hide ajax spinner
				this._themeSpinnerService.hide(targetSpinner, blockerTarget);
				sub.unsubscribe();

			},

			error => {
				if (error.status) {

					if (error.status == '504') {

						this._router.navigate(['504']);

					}

				}

				// catch errors
				if (error.redirect) {

					if (error.typology && error.typology == 'tokenExpired') {

						this._alertService.showModalAlertError('alert.jwt.error.expired', '');
						this._router.navigate(['401']);

					}

				}

				// error callback
				callbackKO(error);

				// hide ajax spinner
				this._themeSpinnerService.hide(targetSpinner, blockerTarget);
				sub.unsubscribe();

			}

		);
		return sub;
	}

}



// WEBPACK FOOTER //
// ./src/app/theme/services/request.service.ts